export default __webpack_public_path__ + "static/media/404.df0ae043.svg";